import React from 'react';
import PropTypes from 'prop-types';
import style from '../../../styles/styles';
import { Paper, List, Subheader, TextField } from 'material-ui';
import Loading from '../../common/Loading/Loading';
import withTranslation from '../../../hoc/withTranslation';

class KeycloakSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func,
    };

    static defaultProps = {
        app: null,
        loading: false,
    };

    handleKeycloakIssuer = (event) => {
        let value;
        if (!event.target.value) {
            value = null;
        } else {
            value = event.target.value;
        }
        this.props.editConfiguration('keycloak_issuer', value);
    };
    handleKeycloakAudience = (event) => {
        let value;
        if (!event.target.value) {
            value = null;
        } else {
            value = event.target.value;
        }
        this.props.editConfiguration('keycloak_audience', value);
    };
    handleKeycloakJwksUri = (event) => {
        let value;
        if (!event.target.value) {
            value = null;
        } else {
            value = event.target.value;
        }
        this.props.editConfiguration('keycloak_jwks_uri', value);
    };

    render() {
        const {
            loading,
            app,
        } = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else {
            content = <div>
                <TextField
                    floatingLabelText={this.props.t('module.keycloak.keycloak_issuer')}
                    defaultValue={app.configurations.keycloak_issuer}
                    fullWidth={true}
                    onBlur={this.handleKeycloakIssuer}
                />
                <TextField
                    floatingLabelText={this.props.t('module.keycloak.keycloak_audience')}
                    defaultValue={app.configurations.keycloak_audience}
                    fullWidth={true}
                    onBlur={this.handleKeycloakAudience}
                />
                <TextField
                    floatingLabelText={this.props.t('module.keycloak.keycloak_jwks_uri')}
                    defaultValue={app.configurations.keycloak_jwks_uri}
                    fullWidth={true}
                    onBlur={this.handleKeycloakJwksUri}
                />
            </div>;
        }

        return <Paper>
            <List>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('module.keycloak.name')}
                </Subheader>
                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>;
    }
}

export default withTranslation(KeycloakSetting);



// WEBPACK FOOTER //
// src/components/common/KeycloakSetting/KeycloakSetting.js